// pre-defined value to check the status of internet

export const getPingStatus = pingValue => {
  if (pingValue > 10) {
    return 'Slow';
  }
  if (pingValue > 5 && pingValue <= 10) {
    return 'Average';
  }

  return 'Good';
};

export const getSpeedStatus = speedValue => {
  if (speedValue < 8) {
    return 'Slow';
  }
  if (speedValue >= 8 && speedValue < 15) {
    return 'Average';
  }

  return 'Good';
};
